import { Box, Typography } from '@mui/material';
import { useAuthStore } from '@store/authStore';
import { useNavigate, useLocation } from 'react-router-dom';

import { NAV_ITEMS } from './navItems';

export const TopbarNav = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const user = useAuthStore((s) => s.user);

  const visibleNavItems = NAV_ITEMS.filter((item) => !item.adminOnly || user?.role === 'admin');

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, minWidth: 0, gap: '4px', overflow: 'hidden' }}>
      {visibleNavItems.map(({ label, Icon, route }) => {
        const active = route ? pathname.startsWith(route) : false;
        return (
          <Box
            key={label}
            onClick={() => route && navigate(route)}
            sx={(theme) => ({
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              px: '10px',
              py: '8px',
              borderRadius: '10px',
              bgcolor: active ? theme.palette.status.info.bg : 'transparent',
              cursor: route ? 'pointer' : 'default',
              '&:hover': { bgcolor: active ? theme.palette.status.info.bg : route ? theme.palette.grey[50] : 'transparent' },
            })}
          >
            <Icon sx={(theme) => ({ fontSize: 15, color: active ? theme.palette.primary.main : theme.palette.grey[500] })} />
            <Typography
              sx={(theme) => ({ fontSize: '14px', fontWeight: 500, color: active ? theme.palette.primary.main : theme.palette.grey[500], lineHeight: '20px', whiteSpace: 'nowrap' })}
            >
              {label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};
